
import Vue from "vue";
import Component from "vue-class-component";
import * as https from "../../api/index";
import { Getter, Action } from "vuex-class";
import Pagination from "@components/base/pagination/CenterPagination.vue";
import { getFormatDate } from "@/common/utils";
import { getToolsPageList } from "@/api/policyTools";
import { search_policy_data, search_count_data } from "@/api/policy";
import { getCompany } from "@/api/account";
@Component({
  name: "Home",
  components: { Pagination },
})
export default class CompanyHome extends Vue {
  @Action("policy/getMatchList") private getMatchList: any;
  @Action("policy/getPublicyList") private getPublicyList: any;
  @Action("policy/getPolicyList") private getPolicy: any;
  @Getter("id") private userId!: string;
  @Getter("city") private city: any;
  @Getter("unitId") private unitId!: string;
  @Getter("role") private roles!: string;
  @Getter("thisIdNature") private idNature!: string;
  @Getter("userName") private userName!: string;
  @Getter("phone") private phone!: string;
  id: any = this.$store.state.account.id;
  loading: any = false;
  currentPage = 0;
  pages = 0;
  total = 0;
  size: any = 10;
  current = 1;
  $https: any;
  unitName = "";
  unitCode = "";
  // userName = "";
  sfzhm = "";
  // phone = '';
  allSubscription = 0;
  addSubscription = 0;
  allOrderNum = 0;
  addOrderNum = 0;
  moneyUnit = "元";
  showFlag: any = true;
  btnData = [{ title: "最新政策" } /*{ title: "信息公示" }*/];
  tagList = [];
  statusData = [
    {
      data: 365,
      label: "累计获取金额",
    },
    {
      data: 16,
      label: "已匹配政策",
    },
    {
      data: 3,
      label: "已申请项目",
    },
  ];
  lastData = [
    {
      url: require("@/assets/images/center/home/2-1.png"),
      label: "待提交",
    },
    {
      url: require("@/assets/images/center/home/2-2.png"),
      label: "已提交",
      // label: '待审核',
    },
    {
      url: require("@/assets/images/center/home/2-3.png"),
      label: "审核中",
    },
    {
      url: require("@/assets/images/center/home/2-5.png"),
      label: "已通过",
    },
    {
      url: require("@/assets/images/center/home/2-4.png"),
      label: "未通过",
    },
  ];
  lastData2 = [
    {
      url: require("@/assets/images/center/home/3-1.png"),
      label: "使用帮助",
    },
    {
      url: require("@/assets/images/center/home/3-2.png"),
      label: "常见问题",
    },
    {
      url: require("@/assets/images/center/home/3-3.png"),
      label: "联系客服",
    },
    {
      url: require("@/assets/images/center/home/3-4.png"),
      label: "设置",
    },
  ];
  companydata = [
    {
      url: require("@/assets/images/center/home/renzhengxinxi.png"),
      label: "企业认证信息",
    },
    {
      url: require("@/assets/images/center/home/mimaxiugai.png"),
      label: "密码修改",
    },
  ];
  recomData = [
    // {
    //   title: "支持文旅企业应对新冠肺炎疫情加快转型发展相关措施",
    //   range: "资金支持",
    //   company: "云南省文化和旅游厅",
    //   date: "剩53天",
    // },
    // {
    //   title: "2020年市级文化产业发展专项资金",
    //   range: "资金支持",
    //   company: "昆明市委宣传部",
    //   date: "剩10天",
    // },
    // {
    //   title: "2020年度服务贸易资金专项资金",
    //   range: "资金支持",
    //   company: "禅城区经济和科技促进局",
    //   date: "已截止",
    // },
    // {
    //   title: "支持文旅企业应对新冠肺炎疫情加快转型发展相关措施",
    //   company: "昆明市委宣传部",
    //   date: "2020-07-01至2020-12-30",
    // },
    // {
    //   title: "住宿餐饮业复工营业加快发展资金",
    //   company: "云南省商务厅",
    //   date: " 2020-07-01至2020-12-18",
    // },
  ];
  informData = [
    // {
    //   status: "[已结束]",
    //   title: "2020年“创客中国”云南省中小企业创新创业大赛入围决赛名单公布",
    //   company: "云南省工业和信息化厅",
    //   date: "--",
    // },
  ];
  authern_model = {};
  projectList = [];
  policyTools = [];
  toPublicy(row: any) {
    this.$router.push({
      path: "/detail/publicy",
      query: { publicyId: row.id },
    });
  }
  toPro(type: any) {
    this.$router.push({
      path: `/${this.roles}/pro`,
      query: { page: type },
    });
  }
  toServicePage(type: any) {
    let path = "";
    /*let path = `${this.roles}/subscribe`;

		switch (type) {
			case 0:
				path = `/${this.roles}/help`;
				break;
			case 1:
				path = `/${this.roles}/question`;
				break;
			case 2:
				path = `/${this.roles}/customer`;
				break;
			case 3:
				path = `/${this.roles}/setting`;
				break;
			default:
				break;
		}*/
    if (type == 0) {
      path = "/unit/authern";
    } else {
      path = "/unit/setting";
    }
    this.$router.push({ path: path });
  }
  tableRowClassName({ row, rowIndex }: any) {
    if (rowIndex % 2 === 1) {
      return "success-row";
    } else if (rowIndex % 2 === 0) {
      return "warning-row";
    }
    return "";
  }
  currentOptionChange(param: any) {
    this.currentPage = param;
    this.current = 1;
    if (param === 1) {
      this.getPublicyData();
    } else if (this.roles !== "person") {
      this.getRecomData();
    }
  }
  currentChange(param: number) {
    this.current = param;
    this.getPolicyData();
  }
  created() {
    console.log(this.idNature, 888);
    if (this.idNature == "person") {
      // 个人用户
      this.showFlag = false;
    } else {
      // 企业用户
      this.showFlag = true;
    }
    this.getData();
  }
  getTag() {
    if (this.roles === "unit" && this.unitName) {
      const req = {
        url: `/zst/page/user/work/getLabelsByCompanyName`,
        data: { name: this.unitName },
      };
      https
        ._get(req)
        .then((res: any) => res.data.labels)
        .then((data: any) => {
          this.tagList = data.slice(0, 3);
        });
    }
  }
  getData() {
    // this.getNumberData(); // 获得工作台相应的数量
    // if (this.roles != "person") {
    // 	this.getRecomData(); // 首页获得政策匹配
    // }
    // this.getOrderNumberData(); // 获得订单数量
    // this.getSubscribeNumberData(); // 获得订单数量
    // this.getCodeData(); // 获取公司基本信息
    // this.getPublicyData(); // 获取信息公示数据
    // this.getRecomData(); // 获取信息公示数据

    if (this.idNature == "person") {
      // 个人用户
      this.showFlag = false;
    } else {
      // 企业用户
      this.showFlag = true;
      this.getCompanyData();
    }

    this.getProjectNumberData();
    this.getProjectPolicyData();
    this.getPolicyTools();
    this.getPolicyData();
  }
  getCompanyData() {
    getCompany({}).then((res: any) => {
      this.authern_model = res.data.result;
    });
  }
  toAllProject() {
    this.$router.push({ path: "/pcm/apply" });
  }
  toViewProject(obj: any) {
    this.$router.push({
      path: "/detail/apply",
      query: { projectId: obj.declareItemId, directionId: obj.id },
    });
  }
  getProjectNumberData() {
    this.statusData = [
      {
        label: "无申请兑现",
        value: 16,
        key: "wushenqingduixian",
      },
      {
        label: "申报项目",
        value: 8,
        key: "shenbao",
      },
      {
        label: "政策收藏",
        value: 1003,
        key: "shoucang",
      },
      {
        label: "订阅",
        value: 3,
        key: "dingyue",
      },
    ];
    search_count_data({}).then((res: any) => {
      if (res.data.success) {
        let datas = res.data.result;
        this.statusData.map((item) => {
          item.value = datas[item.key];
          return item;
        });
      }
    });
  }
  getRecomData() {
    let options: any = {
      current: this.current,
      size: this.size,
    };
    this.getMatchList(options)
      .then(({ code, data, msg }: any) => {
        if (code === 0) {
          this.loading = false;
          const { total, list, count } = data;
          const policy_arr: any = [];
          this.recomData = list.map((item: any) => {
            item.releaseTime = getFormatDate(item.releaseTime);
            return item;
          });
          this.total = count;
          this.pages = count / this.size;
          return data;
        }
      })
      .finally(() => (this.loading = false));
  }
  getPublicyData() {
    let options: any = {
      current: this.current,
      size: this.size,
      addressCode: null,
    };
    setTimeout(() => {
      this.loading = false;
    }, 30000);
    this.getPublicyList(options).then(({ code, data, msg }: any) => {
      if (code === 0) {
        this.loading = false;
        const { total, records, pages } = data;
        const policy_arr: any = [];
        this.informData = records.map((item: any) => {
          item.releaseDate = getFormatDate(item.releaseDate);
          return item;
        });
        this.total = total;
        this.pages = pages;
      }
    });
  }
  getProjectPolicyData() {
    search_policy_data({
      pageNumber: 1,
      pageSize: 8,
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
      state: 2,
    }).then((res) => {
      if (res.data.success) {
        this.projectList = res.data.result.records;
      }
    });
  }
  getPolicyTools() {
    getToolsPageList({ pageSize: 3, pageNumber: 1 }).then((res: any) => {
      if (res.data.success) {
        this.policyTools = res.data.result.records;
      }
    });
  }
  toViewPolicyTool(obj: any) {
    this.$router.push({
      path: "/pcm/verify",
      query: { policyId: obj.id, name: obj.name },
    });
  }
  toViewPolicy(obj: any) {
    this.$router.push({ path: "/detail/policy", query: { publicyId: obj.id } });
  }
  getPolicyData() {
    this.loading = true;

    let options: any = {
      pageNumber: this.current,
      pageSize: 10,
      bigClass: "政策库",
      // unscrambleType: "文字解读",
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
      addressCode: this.city.locationAddressCode,
      listType: 1,
    };
    if (!this.city.locationAddressCode) {
      options.addressCode = this.city.id;
    }

    this.getPolicy(options).then(({ code, result }: any) => {
      if (code === 200 && result) {
        const { totalElements, content, totalPages } = result;
        /*	this.recomData = content.map((item: any) => {
					item = item.content;
					item.withPicturesUrl = null;
					return item;
				});*/
        this.recomData = content.map((item: any) => item.content);
        this.total = totalElements;
        this.pages = totalPages;
        this.loading = false;
      }
    });
  }
  // -------------------------------------获取home页数据start-------------------------------------
  // 获取个人/公司基本信息
  // getCodeData() {
  // 	const url = `/zst/page/user/getCode`;
  // 	const req = {
  // 		url: url,
  // 		data: {
  // 			unitId: this.userId
  // 		}
  // 	};
  // 	https
  // 		._get(req)
  // 		.then((res: any) => {
  // 			const { code, data, msg } = res.data;
  // 			if (code === 0) {
  // 				// 企业信息
  // 				if (data.unitCode) {
  // 					this.unitName = data.unitCode.unitName;
  // 					this.unitCode = data.unitCode.creditCode;
  // 				}
  // 				// 个人信息
  // 				if (data.userCode) {
  // 					this.userName = data.userCode.userName;
  // 					this.sfzhm = data.userCode.papersNumber;
  // 					// this.phone = '13322223333';
  // 				}
  // 			}
  // 		})
  // 		.then(() => this.getTag());
  // }
  // 获得工作台相应的数量(累计获取金额 + 已申请项目)
  getNumberData() {
    const url = `/zst/page/user/work/getNumber`;
    const req = {
      url: url,
      data: {},
    };
    https._get(req).then((res: any) => {
      const { code, data, msg } = res.data;
      if (code === 0) {
        const list = this.statusData;
        if (data.totalMoney > 10000) {
          this.moneyUnit = "万元";
        } else {
          this.moneyUnit = "元";
        }
        list[0].data = Number(
          data
            ? data.totalMoney % 10000 === 0
              ? data.totalMoney / 10000
              : (data.totalMoney / 10000).toFixed(2)
            : 0
        ); // 累计获取金额
        list[1].data = data ? data.policyNumber : 0; // 已匹配政策
        list[2].data = data ? data.projectNumber : 0; // 已申请项目
        this.statusData = list;
      }
    });
  }
  // 获得订单数量
  getOrderNumberData() {
    const url = `/zst/page/user/work/getOrderNumber`;
    const req = {
      url: url,
      data: {},
    };
    https._get(req).then((res: any) => {
      const { code, data, msg } = res.data;
      if (code === 0) {
        this.addOrderNum = data ? data.addNumber : 0; // 新增订阅
        const list = this.statusData;
        this.statusData = list;
        this.allOrderNum = data ? data.allNumber : 0; // 累计订阅
      }
    });
  }
  getSubscribeNumberData() {
    const url = `zst/page/user/subscribe/getUserSubscribeNumber`;
    const req = {
      url: url,
    };
    https._post(req).then((res: any) => {
      const { code, data, msg } = res.data;
      if (code === 0) {
        this.addSubscription = data ? data.newNumber : 0; // 新增订单
        this.allSubscription = data ? data.number : 0; // 累计订单
      }
    });
  }
  // -------------------------------------获取home页数据end-------------------------------------
}
